import { render, staticRenderFns } from "./ReviewIndex.vue?vue&type=template&id=5401a6c7&scoped=true"
import script from "./ReviewIndex.vue?vue&type=script&lang=js"
export * from "./ReviewIndex.vue?vue&type=script&lang=js"
import style0 from "./ReviewIndex.vue?vue&type=style&index=0&id=5401a6c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401a6c7",
  null
  
)

export default component.exports